import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { getProfileInfo, updateProfile } from "../../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import AccountWidget from "../../components/shared/AccountWidget";

import CategoriesWidget from "../../components/shared/CategoriesWidget";

import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";

import styles from "../../thema/style";

class Profile extends Component {
  state = {
    email: "",
    full_name: "",
    phone: "",
    errors: []
  };

  componentDidMount() {
    this.props.getProfileInfo(data => {
      this.setState({
        email: data.email,
        full_name: data.full_name,
        phone: data.phone
      });
    });
  }

  renderErrorMessage() {
    if (this.props.customer.errors.length > 0) {
      return (
        <div className="alert alert-danger" role="alert" style={{ marginTop: 20 }}>
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.props.customer.errors.map((error, i) => (
                <li key={i}>{error.message}</li>
              ))}
            </ul>
          </p>
        </div>
      );
    }

    if (this.state.errors.length > 0) {
      return (
        <div className="alert alert-danger" role="alert" style={{ marginTop: 20 }}>
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.state.errors.map((error, i) => <li key={i}>{error}</li>)}
            </ul>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  validate = () => {
    const errors = [];
    if (!this.state.full_name)
      errors.push("Adınız Soyadınız alanı boş bırakılamaz!");
    if (!this.state.email) errors.push("E-Mail alanı boş bırakılamaz!");
    return errors;
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    this.setState({ errors: this.validate() });
    if (this.state.errors.length === 0) {
      this.props.updateProfile({ ...this.state });
    }
  };

  render() {
    if (this.props.customer.fetching) {
      return <Loading text={"Sayfa Yükleniyor..."} />;
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap"
              // state: { referrer: currentLocation }
            }}
          />
        );
      }
      if (!this.props.customer.profile) {
        return <Loading text={"Sayfa Yükleniyor..."} />;
      }
      return (
        <React.Fragment>
          <PageTitle title={"Profilimi Düzenle"} />
          <div className="row">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"} style={{ marginTop: 15 }}>
                  <h2>Profilimi Düzenle</h2>
                  <p>Hesap Aytınrılarınız</p>
                  <hr />
                  <form onSubmit={this.onSubmit}>
                    <div className="form-group">
                      <label>Adınız Soyadınız</label>
                      <input
                        type="text"
                        className="form-control"
                        name="full_name"
                        defaultValue={this.state.full_name}
                        placeholder="Adınız Soyadınız"
                        onChange={e => {
                          this.handleChange(e);
                        }}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>E-Mail Adresiniz</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        defaultValue={this.state.email}
                        placeholder="Adınız Soyadınız"
                        onChange={e => {
                          this.handleChange(e);
                        }}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Telefon Numaranız</label>
                      <input
                        type="text"
                        className="form-control"
                        name="phone"
                        defaultValue={this.state.phone}
                        placeholder="Telefon Numaranız"
                        onChange={e => {
                          this.handleChange(e);
                        }}
                      />
                    </div>
                    <button type="submit" className="btn btn-success">
                      Profilimi Güncelle
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={e => {
                        e.preventDefault();
                        this.props.history.push("/hesabim");
                      }}
                    >
                      İptal Et
                    </button>
                  </form>
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { getProfileInfo, updateProfile };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);



// WEBPACK FOOTER //
// ./src/routers/Account/profile.js